export default "__VITE_ASSET__DaumUOhC__"